import React from 'react';
import DefaultWelcome from 'welcome/defaultwelcome/Welcome';
import GadWelcome from 'welcome/gadwelcome/GadWelcome';
import RmeqWelcome from 'welcome/rmeqwelcome/WelcomeRmeq';
import { AdhdWelcome } from 'welcome/adhdwelcome/AdhdWelcome';
import { useFeatures } from 'useFeatures';
import { LivenWelcome } from 'welcome/livenwelcome/LivenWelcome';
import { useGrowthBook } from '@growthbook/growthbook-react';
import { LoadingScreen } from 'components/loadingscreen/LoadingScreen';
import { CreoQuizWelcome } from 'welcome/creoquizwelcome/CreoQuizWelcome';

const Welcome = () => {
  const growthbook = useGrowthBook();

  const {
    isAdhdTest,
    isDefaultOnboarding,
    isGadTest,
    isLivenOnboardingFlow,
    isCreoQuiz,
  } = useFeatures();

  if (!growthbook.ready) {
    return <LoadingScreen isVisible={true} title="Loading..." description="" />;
  }

  if (isCreoQuiz) {
    return <CreoQuizWelcome />;
  }

  if (isGadTest) {
    return <GadWelcome />;
  }
  if (isDefaultOnboarding) {
    return <DefaultWelcome />;
  }
  if (isAdhdTest) {
    return <AdhdWelcome />;
  }
  if (isLivenOnboardingFlow) {
    return <LivenWelcome />;
  }
  return <RmeqWelcome />;
};

export default Welcome;
